import { locale as toast } from '../components/toast/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...toast.data
    }
};